import { render, staticRenderFns } from "./corresponsalia-cuadre.vue?vue&type=template&id=65c35fad&scoped=true&"
import script from "./corresponsalia-cuadre.vue?vue&type=script&lang=js&"
export * from "./corresponsalia-cuadre.vue?vue&type=script&lang=js&"
import style0 from "./corresponsalia-cuadre.vue?vue&type=style&index=0&id=65c35fad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c35fad",
  null
  
)

export default component.exports